<template>
    <div class="agreement">
        <div class="agree-wrapper">
            <div class="agree-list">
                <div class="list-item" @click="type='user'">
                    <div class="item-preview">
                        <div class="preview-content" v-html="setting.userAgreement"></div>
                    </div>
                    <div class="item-title">《用户行为准则》</div>
                </div>
                <div class="list-item" @click="type='privacy'">
                    <div class="item-preview">
                        <div class="preview-content" v-html="setting.privacy"></div>
                    </div>
                    <div class="item-title">《设计师合作协议》</div>
                </div>
                <div class="list-item" @click="type='orderPurchase'">
                    <div class="item-preview">
                        <div class="preview-content" v-html="setting.orderPurchaseAgreement"></div>
                    </div>
                    <div class="item-title">《订单采购合同》</div>
                </div>
            </div>
            <div class="agree-content" v-html="agreement"></div>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex';
export default{
    data(){
        return{
            type:'user'
        }
    },
    computed:{
        ...mapState({
            setting:state=>state.setting
        }),
        agreement(){
            const {userAgreement,privacy,orderPurchaseAgreement} = this.setting;
            if(this.type === 'user') return userAgreement;
            if(this.type === 'orderPurchase') return orderPurchaseAgreement;
            return privacy;
        }
    },
    mounted(){},
    methods:{}
}
</script>
<style lang="scss" scoped>
.agreement{
    width:100%;
    min-height:calc(100vh - 165px);
    background:#f8f6f9;
    .agree-wrapper{
        width:100%;
        padding:40px 0 0 60px;
        display:flex;
        column-gap:74px;
        .agree-list{
            display:flex;
            flex-direction:column;
            row-gap:26px;
            width:fit-content;
            .list-item{
                display:flex;
                flex-direction:column;
                align-items:center;
                justify-content:center;
                row-gap:10px;
                width:fit-content;
                cursor:pointer;
                .item-preview{
                    width:120px;
                    height:150px;
                    background:#ffffff;
                    overflow:hidden;
                    border:1px solid #e0e0e0;
                    padding:3px;
                    .preview-content{
                        width:100%;
                        zoom:0.15;
                    }
                }
                .item-title{
                    color:#4d4d4d;
                    font-size:14px;
                }
            }
        }
        .agree-content{
            width:1000px;
            max-height:calc(100vh - 210px);
            background:#ffffff;
            padding:40px 50px;
            overflow-y:auto;
        }
    }
}
</style>